import { firePickerDone } from "@/components/connectors/slack/firePickerDone.ts";
import { SlackChannelPickerForm } from "@/components/connectors/slack/SlackChannelPickerForm.tsx";
import type { PickerArtifact } from "@/types/artifacts.ts";

/**
 * The Slack channels card, sized for the omnibox. Its own button adds okthx to
 * the checked channels and then finishes the card: the join is the answer, so
 * a second press of Done would only be ceremony. Done stays for someone who
 * wants none of them.
 */
export const SlackChannelsOmniPickerBody = ({
  picker,
  teamId,
}: {
  picker: PickerArtifact;
  teamId: string;
}) => (
  <SlackChannelPickerForm
    teamId={teamId}
    scrollClassName="max-h-[137px] md:max-h-[209px]"
    onJoined={() => void firePickerDone(picker.actions)}
  />
);
